import styles from './OptionalNumberCell.module.css';

interface OptionalNumberCellProps {
  value: number | undefined;
  /** Shown in place of the value when it is unset, and as the input placeholder while editing. */
  emptyLabel: string;
  isEditing: boolean;
  editingValue: string;
  onChange: (value: string) => void;
  onSave: () => void;
  onCancel: () => void;
}

/** Table cell for an optional positive integer (capacity limit, priority, ...). */
export const OptionalNumberCell = ({
  value,
  emptyLabel,
  isEditing,
  editingValue,
  onChange,
  onSave,
  onCancel
}: OptionalNumberCellProps) => {
  if (!isEditing) {
    return <span>{value ?? emptyLabel}</span>;
  }

  return (
    <input
      className={styles.input}
      type="number"
      min={1}
      value={editingValue}
      placeholder={emptyLabel}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') onSave();
        else if (e.key === 'Escape') onCancel();
      }}
    />
  );
};
